import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {
    UntypedFormGroup,
    UntypedFormControl,
    Validators,
    UntypedFormBuilder,
} from '@angular/forms';
import { ProjectionService } from '../../../performance/services/projection.service';
import { ToastService } from '../../../shared/services/toast.service';
import { ReusableFunctions } from '../../../shared/classes/reusable-functions';
import { BranchProjectionOpenCloseDates } from '../../../performance/components/performance-projections-config/performance-projection.data';

@Component({
    selector: 'app-branch-projections-config',
    templateUrl: './branch-projections-config.component.html',
    styleUrls: ['./branch-projections-config.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
})
export class BranchProjectionsConfigComponent implements OnInit {
    projectionsDateForm: UntypedFormGroup;
    currentYear: number;
    loading: boolean = false;

    constructor(
        private formBuilder: UntypedFormBuilder,
        private projectionService: ProjectionService,
        private toast: ToastService,
        private reusableFunctions: ReusableFunctions
    ) {
        this.projectionsDateForm = this.createFormGroup();
    }

    ngOnInit() {
        scroll(0, 0);
        this.currentYear = new Date().getUTCFullYear();
        this.projectionService.getBranchProjectionOpenCloseDates().subscribe((dates) => {
            this.significantDatesHandler(dates);
        });
        this.onChanges();
    }

    significantDatesHandler(dates: BranchProjectionOpenCloseDates[]) {
        if (dates) {
            this.currentYearOpenDate.setValue(
                this.reusableFunctions.getDateFromDateTimeOffset(dates[0].openDate)
            );
            this.currentYearClosingDate.setValue(
                this.reusableFunctions.getDateFromDateTimeOffset(dates[0].closingDate)
            );
            this.nextYearOpenDate.setValue(
                this.reusableFunctions.getDateFromDateTimeOffset(dates[1].openDate)
            );
            this.nextYearClosingDate.setValue(
                this.reusableFunctions.getDateFromDateTimeOffset(dates[1].closingDate)
            );
        } else {
            throw new Error('The branch projection service failed to return open/close dates.');
        }
    }

    createFormGroup(): UntypedFormGroup {
        return this.formBuilder.group({
            currentYearOpenDate: new UntypedFormControl('', Validators.required),
            currentYearClosingDate: new UntypedFormControl('', Validators.required),
            nextYearOpenDate: new UntypedFormControl('', Validators.required),
            nextYearClosingDate: new UntypedFormControl('', Validators.required),
        });
    }

    get currentYearOpenDate() {
        return this.projectionsDateForm.get('currentYearOpenDate');
    }

    get currentYearClosingDate() {
        return this.projectionsDateForm.get('currentYearClosingDate');
    }

    get nextYearOpenDate() {
        return this.projectionsDateForm.get('nextYearOpenDate');
    }

    get nextYearClosingDate() {
        return this.projectionsDateForm.get('nextYearClosingDate');
    }

    onChanges() {
        this.currentYearOpenDate.valueChanges.subscribe((val) => {
            //validation
        });
        this.currentYearClosingDate.valueChanges.subscribe((val) => {
            //validation
        });
        this.nextYearOpenDate.valueChanges.subscribe((val) => {
            //validation
        });
        this.nextYearClosingDate.valueChanges.subscribe((val) => {
            //validation
        });
    }

    onSubmit() {
        this.loading = true;
        this.projectionsDateForm.markAsPristine();
        this.projectionService.setOpenClosedDates(this.formatFormData()).subscribe(
            () => {
                this.toast.success('Dates changed successfully.');
                this.loading = false;
            },
            () => {
                this.toast.warning('Something went wrong saving these dates.');
                this.loading = false;
            }
        );
    }

    formatFormData(): BranchProjectionOpenCloseDates[] {
        return [
            {
                projectionYear: this.currentYear,
                openDate: this.currentYearOpenDate.value,
                closingDate: this.currentYearClosingDate.value,
            },
            {
                projectionYear: this.currentYear + 1,
                openDate: this.nextYearOpenDate.value,
                closingDate: this.nextYearClosingDate.value,
            },
        ];
    }
}
